import React, { useState } from 'react';
import { Modal, Form, Input, Row, Col, Button, message } from 'antd';
import { MailOutlined, UserOutlined } from '@ant-design/icons';
import axios from 'axios';

function Register({ visible, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleRegister = async (values) => {
    try {
      setLoading(true);
      const authToken = localStorage.getItem('authToken');

      await axios.post(`${process.env.REACT_APP_API_URL}/register`, {
        username: values.username,
        password: values.password,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName
      }, {
        headers: { Authorization: `Bearer ${authToken}` }
      });

      message.success('Usuario registrado exitosamente');
      form.resetFields();
      onSuccess();
      onClose();

    } catch (error) {
      message.error(error.response?.data?.error || 'Error al registrar usuario');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      onOk={() => form.submit()}
      confirmLoading={loading}
      title="Registrar Nuevo Usuario"
      okText="Registrar"
      cancelText="Cancelar"
      centered
      bodyStyle={{ backgroundColor: '#353435' }}
      style={{ top: 50 }}
      okButtonProps={{
        style: {
          backgroundColor: '#f49b33',
          borderColor: '#f49b33',
          color: '#fff'
        }
      }}
      cancelButtonProps={{
        style: {
          color: '#f49b33',
          borderColor: '#f49b33',
          backgroundColor: '#353435'
        }
      }}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleRegister}
        style={{ color: '#fff' }}
      >
        <Form.Item
          name="username"
          label={<span style={{ color: '#fff' }}>Usuario</span>}
          rules={[{ required: true, message: 'Ingresa un usuario' }]}
        >
          <Input prefix={<UserOutlined />} style={{ backgroundColor: '#2a2b2b', color: '#fff' }} />
        </Form.Item>

        <Form.Item
          name="email"
          label={<span style={{ color: '#fff' }}>Correo</span>}
          rules={[{ required: true, type: 'email', message: 'Ingresa un correo válido' }]}
        >
          <Input prefix={<MailOutlined />} style={{ backgroundColor: '#2a2b2b', color: '#fff' }} />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="firstName"
              label={<span style={{ color: '#fff' }}>Nombre</span>}
              rules={[{ required: true, message: 'Ingresa el nombre' }]}
            >
              <Input style={{ backgroundColor: '#2a2b2b', color: '#fff' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="lastName"
              label={<span style={{ color: '#fff' }}>Apellido</span>}
              rules={[{ required: true, message: 'Ingresa el apellido' }]}
            >
              <Input style={{ backgroundColor: '#2a2b2b', color: '#fff' }} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="password"
          label={<span style={{ color: '#fff' }}>Contraseña</span>}
          rules={[{ required: true, message: 'Ingresa una contraseña' }]}
        >
          <Input.Password style={{ backgroundColor: '#2a2b2b', color: '#fff' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default Register;